const doc = [({"en":({"js":({"merfoto":({"basket":({"unique_photos_label":({"photo_s":"Photo(s)"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;